import { enumify, isArrayOf, isObjectLike, isString, TypeGuard } from '../../lib/typeInference.js';
import { isMetricDefinitionBase, MetricDefinition } from './metric.types.js';
import { isPeriodNamed, PeriodNamed } from './period.types.js';

export interface SegmentUserQuery {
    segmentId: string; // backwards compatible
}

export const segmentFacts = ['ATV', 'TotalSpend', 'OrderCount'] as const;

export type SegmentFactType = (typeof segmentFacts)[number];

export const SegmentFactEnum = enumify(segmentFacts);

// Pipeline performance: is it better to define 1 fact / query per pipeline, or multiple facts per 1 period,
// or 1 fact per multiple periods?
export interface SegmentMetricDefinition<IDTYPE> extends MetricDefinition<'SegmentMetric', IDTYPE> {
    factType: SegmentFactType;
    query: SegmentUserQuery;
    periods: PeriodNamed[];
}

export type SegmentMetricDefinitionCreate<IDTYPE> = Omit<SegmentMetricDefinition<IDTYPE>, '_id' | 'tenantId' | 'metricClass'>;

export type SegmentMetricDefinitionUpdate<IDTYPE> = Partial<SegmentMetricDefinitionCreate<IDTYPE>>;

export function isSegmentMetricDefinition<IDTYPE>(obj: unknown, isIDTYPE: TypeGuard<IDTYPE>): obj is SegmentMetricDefinition<IDTYPE> {
    return (
        isObjectLike(obj) &&
        segmentFacts.includes(obj.factType as any) &&
        isObjectLike(obj.query) &&
        isString(obj.query.segmentId) &&
        isArrayOf(isPeriodNamed, obj.periods) &&
        isMetricDefinitionBase(obj, 'SegmentMetric', isIDTYPE)
    );
}
